import { mapState, mapGetters, mapActions } from 'vuex'

export const adminNotificationAgentComputed = {
  ...mapState('adminNotificationAgent', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('adminNotificationAgent', [
    'getChartDataNotificationAgentAdmin',
  ]),
}

export const adminNotificationAgentMethods = mapActions(
  'adminNotificationAgent',
  ['fetchingChartDataNotificationAgentAdmin']
)
